import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory}  from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from './Menu';
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from '../helper/GetFetch';
import ShortData from '../helper/ShortData';
import loadMenu from '../js/main';
import Footer from './Footer';

const ORDEN_DIAS = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];

// Normaliza "Miércoles", "MIERCOLES " → "miercoles"
const normalizarDia = (dia) =>
  String(dia || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

const capitalizar = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

// Agrupa el horario (materia → días) en días (día → clases)
const agruparPorDia = (materias) => {
  const dias = new Map();
  (materias || []).forEach((m) => {
    (m.data || []).forEach((h) => {
      const clave = normalizarDia(h.diasemana);
      if (!dias.has(clave)) {
        dias.set(clave, { dia: String(h.diasemana || '').trim(), clases: [] });
      }
      dias.get(clave).clases.push({
        materia: m.materia,
        hora: h.hora_inicio,
        seccion: h.seccion,
      });
    });
  });

  const resultado = Array.from(dias.entries());
  resultado.sort((a, b) => {
    const ia = ORDEN_DIAS.indexOf(a[0]);
    const ib = ORDEN_DIAS.indexOf(b[0]);
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  });
  resultado.forEach(([, grupo]) =>
    grupo.clases.sort((a, b) => String(a.hora).localeCompare(String(b.hora), 'es', { numeric: true }))
  );
  return resultado;
};

const Home = () => {

  const history = useHistory();

  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');

  const [horarios, setHorarios] = useState({});
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
       dataUser.token = cred.token;
       dataUser.nombre = cred.nombre;
       dataUser.carnet = cred.carnet;
       dataUser.perfil = cred.perfil;
       dataUser.carrera = cred.carrera;

      let horariosMaterias = GetFetch.horarios(cred.carnet, cred.token);

      horariosMaterias.then((dataMateHora) => {
        setHorarios(ShortData.MateriaHoraios(dataMateHora));
        setCargando(false);
      }).catch(() => setCargando(false));

      loadMenu();
    }else{
      history.push("/");
    }
  },[datos, history, dataUser]);

  const semana = horarios.length > 0 ? agruparPorDia(horarios) : [];
  const hoy = ORDEN_DIAS[(new Date().getDay() + 6) % 7];
  const totalMaterias = horarios.length > 0 ? horarios.length : 0;

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto
            foto={dataUser.carnet}
            alt="Foto alumno"
            tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            perfil={dataUser.perfil}
            carrera={dataUser.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Horario de clases</h2>

        {cargando ? (
          <div className="esen-week">
            <SkeletonCard rows={4} />
            <SkeletonCard rows={4} />
            <SkeletonCard rows={4} />
          </div>
        ) : semana.length > 0 ? (
          <>
            <p className="text-muted mb-3">
              {totalMaterias} materias inscritas este ciclo
            </p>
            <div className="esen-week">
              {semana.map(([clave, grupo]) => (
                <div
                  key={clave}
                  className={clave === hoy ? 'esen-day esen-day--today' : 'esen-day'}
                >
                  <div className="esen-day-name">
                    <span>{capitalizar(normalizarDia(grupo.dia)) || grupo.dia}</span>
                    {clave === hoy ? (
                      <span className="esen-chip esen-chip--info">Hoy</span>
                    ) : null}
                  </div>
                  {grupo.clases.map((c, i) => (
                    <div className="esen-class" key={i}>
                      <span className="esen-class-time">{c.hora}</span>
                      <div>
                        <span className="esen-class-name">{c.materia}</span>
                        <span className="esen-class-sec">Sección {c.seccion}</span>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>
        ) : (
          <EmptyState icon="fa-calendar-o" title="Sin horario asignado">
            Cuando tengas materias inscritas, tu horario semanal aparecerá aquí.
          </EmptyState>
        )}
      </div>
    </div>
  );
};

export default Home;
